import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
    providedIn: 'root'
})

export class PaymentGatewayService {
    constructor(private backendService: BackendService) { }

    private path = '/payment-gateway';

    updatePaymentGateway(gateway: any) {
        return this.backendService.put(this.path, gateway);
    }
    
    
    getPaymentGateway() {
        return this.backendService.get(this.path);
    }
}